



















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { FormBuilderConfig } from "./types/FormBuilderTypes";
import { RouterNames } from "@/router/routernames";
import FormBuilderAIChat from "./components/FormBuilderAIChat.vue";

interface FormWithMeta extends FormBuilderConfig {
  id: string;
  createdAt: string;
  updatedAt: string;
}

@Component({
  components: {
    FormBuilderAIChat,
  },
})
export default class FormBuilderList extends Vue {
  public headers = [
    { text: "Nombre", value: "formName", sortable: true },
    { text: "Campos", value: "fieldCount", sortable: true },
    { text: "Tabs", value: "tabCount", sortable: true },
    { text: "Creado", value: "createdAt", sortable: true },
    { text: "Acciones", value: "actions", sortable: false, align: "end" },
  ];

  public forms: FormWithMeta[] = [];
  public loading: boolean = false;
  public jsonDialog: boolean = false;
  public deleteDialog: boolean = false;
  public showAiDialog: boolean = false;
  public editingForm: FormWithMeta | null = null;
  public selectedForm: FormWithMeta | null = null;

  public async created() {
    await this.loadForms();
  }

  public async loadForms() {
    this.loading = true;
    try {
      const savedForms = localStorage.getItem("formBuilder_forms");
      if (savedForms) {
        this.forms = JSON.parse(savedForms);
      } else {
        this.forms = [];
      }
    } catch (error) {
      console.error("Error loading forms:", error);
    } finally {
      this.loading = false;
    }
  }

  public goToNew() {
    this.$router.push({ name: RouterNames.form_builder });
  }

  public editForm(form: FormWithMeta) {
    sessionStorage.setItem("formBuilder_editing", JSON.stringify(form));
    this.$router.push({ name: RouterNames.form_builder });
  }

  public editWithAI(form: FormWithMeta) {
    console.log("🤖 Editando formulario con IA:", form);
    this.editingForm = form;
    this.showAiDialog = true;
  }

  public closeAiDialog() {
    this.showAiDialog = false;
    this.editingForm = null;
  }

  public cloneForm(form: FormWithMeta) {
    const cloned: FormWithMeta = {
      ...form,
      id: this.generateId(),
      formName: `${form.formName} (Copia)`,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };

    this.forms.push(cloned);
    this.saveForms();

    sessionStorage.setItem("formBuilder_editing", JSON.stringify(cloned));
    this.$router.push({ name: RouterNames.form_builder });
  }

  public viewJson(form: FormWithMeta) {
    this.selectedForm = form;
    this.jsonDialog = true;
  }

  public confirmDelete(form: FormWithMeta) {
    this.selectedForm = form;
    this.deleteDialog = true;
  }

  public async deleteForm() {
    if (!this.selectedForm) return;

    try {
      const index = this.forms.findIndex((f) => f.id === this.selectedForm!.id);
      if (index !== -1) {
        this.forms.splice(index, 1);
        this.saveForms();
      }

      this.deleteDialog = false;
      this.selectedForm = null;
    } catch (error) {
      console.error("Error deleting form:", error);
    }
  }

  public copyJson() {
    if (this.selectedForm) {
      navigator.clipboard.writeText(this.selectedFormJson);
      alert("JSON copiado al portapapeles");
    }
  }

  public get selectedFormJson(): string {
    if (!this.selectedForm) return "";
    return JSON.stringify(this.selectedForm, null, 2);
  }

  public goToExamples() {
    this.$router.push({ name: RouterNames.clientes_ejemplo });
  }

  public formatDate(date: string): string {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleDateString("es-ES", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  private saveForms() {
    localStorage.setItem("formBuilder_forms", JSON.stringify(this.forms));
  }

  public onFormGenerated(config: FormBuilderConfig) {
    console.log("📝 FormBuilderList recibió config:", config);

    if (this.editingForm) {
      // MODO EDICIÓN
      console.log("✏️ Actualizando formulario existente");

      const updatedForm: FormWithMeta = {
        ...config,
        id: this.editingForm.id,
        createdAt: this.editingForm.createdAt,
        updatedAt: new Date().toISOString(),
      };

      const index = this.forms.findIndex((f) => f.id === this.editingForm!.id);
      if (index !== -1) {
        this.forms.splice(index, 1, updatedForm);
        this.saveForms();
        console.log("💾 Formulario actualizado");
      }

      this.closeAiDialog();
      sessionStorage.setItem(
        "formBuilder_editing",
        JSON.stringify(updatedForm)
      );
      this.$router.push({ name: RouterNames.form_builder });
    } else {
      // MODO CREACIÓN
      console.log("➕ Creando nuevo formulario");

      const newForm: FormWithMeta = {
        ...config,
        id: this.generateId(),
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };

      this.forms.push(newForm);
      this.saveForms();
      console.log("💾 Formulario guardado. Total:", this.forms.length);

      this.closeAiDialog();
      sessionStorage.setItem("formBuilder_editing", JSON.stringify(newForm));
      this.$router.push({ name: RouterNames.form_builder });
    }
  }

  private generateId(): string {
    return `form_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
}
